export default __webpack_public_path__ + "images/0x78b3c724a2f663d11373c4a1978689271895256f.png";